import { render, staticRenderFns } from "./OSmsErrorComp.vue?vue&type=template&id=161a18b2&"
import script from "./OSmsErrorComp.vue?vue&type=script&lang=js&"
export * from "./OSmsErrorComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports